import { render, staticRenderFns } from "./Rehabilitacion.vue?vue&type=template&id=73b8b264&scoped=true"
import script from "./Rehabilitacion.vue?vue&type=script&lang=js"
export * from "./Rehabilitacion.vue?vue&type=script&lang=js"
import style0 from "./Rehabilitacion.vue?vue&type=style&index=0&id=73b8b264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b8b264",
  null
  
)

export default component.exports